export default __webpack_public_path__ + "static/badge-google-play-d2f79ee2f2629e24a62ac31be5eb80a6.png";